import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { AppStore } from './app.types';

const useAppStoreBase = create<AppStore>()(
  devtools(
    set => ({
      // #region States
      state: {
        heartbeatTS: 0,
        publicHeartbeatTS: 0,
      },

      // #endregion

      // #region Actions
      actions: {
        updateHeartbeatTS: () => {
          set(
            state => ({
              state: {
                ...state.state,
                heartbeatTS: new Date().getTime(),
              },
            }),
            false,
            'updateHeartbeatTS'
          );
        },

        updatePublicHeartbeatTS: () => {
          set(
            state => ({
              state: {
                ...state.state,
                publicHeartbeatTS: new Date().getTime(),
              },
            }),
            false,
            'updatePublicHeartbeatTS'
          );
        },
      },

      // #endregion
    }),
    {
      name: 'AppStore',
    }
  )
);

export { useAppStoreBase };
